import { createSlice } from "@reduxjs/toolkit";

export const leadScoring = createSlice({
  name: "leadScoring",
  initialState: {
    leadByEvents: [],
    leadByFields: [],
    scoringRules: [],
    isDuplicateName: false
  },

  reducers: {
    setLeadByEvents: (state, action) => {
      state.leadByEvents = action.payload;
    },
    setLeadByFields: (state, action) => {
      state.leadByFields = action.payload;
    },
    setScoringRules: (state, action) => {
      state.scoringRules = action.payload;
    },
    setIsDuplicateName: (state, action) => {
      state.isDuplicateName = action.payload;
    },
  },
});

export const { 
    setLeadByEvents,
    setLeadByFields,
    setScoringRules,
    setIsDuplicateName 
} = leadScoring.actions;

export const getLeadByEvents = (state) => {
  return state?.leadScoring?.leadByEvents;
};
export const getLeadByFields = (state) => {
  return state?.leadScoring?.leadByFields;
};
export const getScoringRules = (state) => {
  return state?.leadScoring?.scoringRules;
};
export const getIsDuplicateName = (state) => {
  return state?.leadScoring?.isDuplicateName;
};

export default leadScoring.reducer;
